export class SecurityDeposit {
    amount: number = 0;
    percentage: number = 0;
}
